module.exports = {
      id: "web-story-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "svg-sprite-3f41b5422aa8d7a50bd372d0b736cd55.svg#web-story",
      toString: function () {
        return this.url;
      }
    }